// Import all packages from supplier-specific files
import { allPackages, fttbPackageIds } from './suppliers';

// Export the transformed packages
export const transformedPackages = allPackages
  .filter(pkg => pkg.ISP === "Wondernet" && pkg.Title !== "CWMP Internal")
  .map(pkg => ({
    ...pkg,
    id: pkg.ID,
    // Explicitly set connectionType based on package ID
    connectionType: fttbPackageIds.includes(pkg.ID) ? 'FTTB' : 'FTTH',
    productType: fttbPackageIds.includes(pkg.ID) ? 'Business' : 'Home'
  }));

export default transformedPackages;